import { RSAA } from 'redux-api-middleware';
import { createRsaaTypes, createHeaders } from '../actionHelpers';

export const ADMIN_SHOWINGS_GET = 'ADMIN_SHOWINGS_GET';
export const ADMIN_SHOWINGS_CREATE = 'ADMIN_SHOWINGS_CREATE';
export const ADMIN_SHOWINGS_UPDATE = 'ADMIN_SHOWINGS_UPDATE';
export const ADMIN_SHOWINGS_DELETE = 'ADMIN_SHOWINGS_DELETE';

export const getShowing = id => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_SHOWINGS_GET),
        endpoint: `/api/admin/showings/${id}`,
        headers: createHeaders(false),
        method: 'GET'
    }
});

export const createShowing = showing => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_SHOWINGS_CREATE),
        endpoint: '/api/admin/showings',
        headers: createHeaders(true),
        method: 'POST',
        body: JSON.stringify(showing)
    }
});

export const updateShowing = (id, showing) => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_SHOWINGS_UPDATE),
        endpoint: `/api/admin/showings/${id}`,
        headers: createHeaders(true),
        method: 'PUT',
        body: JSON.stringify(showing)
    }
});

export const deleteShowing = id => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_SHOWINGS_DELETE),
        endpoint: `/api/admin/showings/${id}`,
        headers: createHeaders(false),
        method: 'DELETE'
    }
});
